import { IColumnDef } from './models/ui/column-defs/column-def.interface';

export class GridConfig<EntityType> {
  public columnDefs: IColumnDef[] = [];
  public dataSource: EntityType[] = [];
  public displayedColumns: string[] = [];
}
